import React from 'react';
import '../../styles/components/AsperaTransferActivityItem.scss';
import { language } from '../../services/LanguageService';
import { Button, getIcon, getIconComponent } from '../Carbon';
import { openNewTab } from '../../helpers/starterHelpers';
import { coreHelpUrls } from '../../constants/constants';
import { removeTransferItem } from '../../helpers/transfer';
/**
 * React Component
 *
 * The AsperaTransferActivityItem component renders the transfer monitor item (block of a transfer)
 *
 * ISSUES: Where does troubleshoot go?
 *
 * @example
 * ```javascript
 * <AsperaTransferActivityItem transfer={transfer} />
 * ```
 */
export class AsperaTransferActivityItem extends React.Component {
    constructor() {
        super(...arguments);
        this.troubleshootTransfer = () => {
            const { transfer } = this.props;
            if (transfer.type === 'node') {
                openNewTab(coreHelpUrls.nodeHelp, true);
            }
            else if (transfer.type === 'http') {
                openNewTab(coreHelpUrls.httpHelp, true);
            }
            else {
                openNewTab(coreHelpUrls.connectHelp, true);
            }
        };
        this.removeTransfer = () => {
            const { transfer, onRemove } = this.props;
            if (typeof onRemove === 'function') {
                onRemove(transfer);
            }
            removeTransferItem(transfer.id, transfer.type);
        };
    }
    getIcon(icon) {
        switch (icon) {
            case 'upload':
                return getIcon('CloudUpload', undefined, { className: 'transfer-name-icon transfer' });
            case 'download':
                return getIcon('CloudDownload', undefined, { className: 'transfer-name-icon transfer' });
            case 'failed':
                return getIcon('ErrorFilled', undefined, { className: 'transfer-name-icon failed' });
            case 'completed':
                return getIcon('CheckmarkFilled', undefined, { className: 'transfer-name-icon completed' });
        }
    }
    getTransferBar(transfer) {
        if (transfer.supportProgressBar) {
            const styleProps = {
                width: `${transfer.safePercent}%`,
            };
            return (React.createElement("div", { className: "transfer-progress", "data-auto": "transfer-activity-item-progress-container" },
                React.createElement("div", { className: "transfer-progress-details" },
                    React.createElement("div", { className: "transfer-progress-details-item" }, transfer.displayTransferItem)),
                React.createElement("div", { className: "transfer-progress-bar", "data-auto": "transfer-activity-item-progress-bar" },
                    React.createElement("div", { className: "transfer-progress-bar-current", style: styleProps })),
                React.createElement("div", { className: "transfer-progress-time" }, transfer.displayEta ? language.get('transferActivity.etaItem', [transfer.displayEta]) : '')));
        }
    }
    getLeftAction(transfer) {
        const { onCancel } = this.props;
        if (transfer.canCancel) {
            const cancel = () => {
                if (typeof onCancel === 'function') {
                    onCancel(transfer);
                }
                else {
                    transfer.cancel();
                }
            };
            return React.createElement(Button, { kind: "ghost", size: "sm", className: "link-style", onClick: cancel, "data-auto": "transfer-activity-item-action-cancel" }, language.get('transferActivity.cancel'));
        }
    }
    getRightAction(transfer) {
        const { onPause, onResume, onOpenLocalFolder } = this.props;
        if (transfer.canPause) {
            const pause = () => {
                if (typeof onPause === 'function') {
                    onPause(transfer);
                }
                else {
                    transfer.pause();
                }
            };
            return React.createElement(Button, { kind: "ghost", size: "sm", className: "link-style", onClick: pause, "data-auto": "transfer-activity-item-action-pause" }, language.get('transferActivity.pause'));
        }
        else if (transfer.canResume) {
            const resume = () => {
                if (typeof onResume === 'function') {
                    onResume(transfer);
                }
                else {
                    transfer.resume();
                }
            };
            return React.createElement(Button, { kind: "ghost", size: "sm", className: "link-style", onClick: resume, "data-auto": "transfer-activity-item-action-resume" }, language.get('transferActivity.resume'));
        }
        else if (transfer.canOpenLocalFolder) {
            const openLocalFolder = () => {
                if (typeof onOpenLocalFolder === 'function') {
                    onOpenLocalFolder(transfer);
                }
                else {
                    transfer.openLocalFolder();
                }
            };
            return React.createElement(Button, { kind: "ghost", size: "sm", className: "link-style", onClick: openLocalFolder, "data-auto": "transfer-activity-item-action-open-local-folder" }, language.get('transferActivity.viewLocalFolder'));
        }
        else if (transfer.status === 'failed') {
            return React.createElement(Button, { kind: "ghost", size: "sm", className: "link-style", onClick: this.troubleshootTransfer, "data-auto": "transfer-activity-item-action-troubleshoot" }, language.get('transferActivity.troubleshoot'));
        }
    }
    render() {
        const { transfer, className, openTransferInfo } = this.props;
        return (React.createElement("div", { className: `aspera-transfer-activity-item ${className ? className : ''}`, "data-auto": `transfer-activity-item-wrapper-${transfer.id}` },
            React.createElement("div", { className: "transfer-card-actions" },
                React.createElement(Button, { className: "transfer-info-button", onClick: () => openTransferInfo(transfer), size: "sm", kind: "ghost", type: "button", iconDescription: language.get('transferActivity.details'), renderIcon: getIconComponent('Information'), hasIconOnly: true, tooltipPosition: language.leftRightStyle ? 'right' : 'left', "data-auto": `transfer-activity-item-info-button-${transfer.id}` }),
                transfer.canRemove && React.createElement(Button, { className: "transfer-remove-button", onClick: this.removeTransfer, size: "sm", kind: "ghost", type: "button", iconDescription: language.get('transferActivity.removeTransfer'), renderIcon: getIconComponent('Close'), hasIconOnly: true, tooltipPosition: language.leftRightStyle ? 'right' : 'left', "data-auto": `transfer-activity-item-remove-button-${transfer.id}` })),
            React.createElement("div", { className: "app-name" }, transfer.displayAppName),
            React.createElement("div", { className: "transfer-name" },
                this.getIcon(transfer.displayIconKey),
                React.createElement("span", { className: "transfer-name-text" }, transfer.displayTransferName)),
            React.createElement("div", { className: "transfer-details" },
                React.createElement("div", { className: "transfer-details-status" }, transfer.displayDetailsStatus),
                !!transfer.displayTransferSystem && React.createElement("div", { className: "transfer-details-system" }, transfer.displayTransferSystem),
                React.createElement("div", { className: "transfer-details-summary" }, transfer.displayDetailSummary)),
            this.getTransferBar(transfer),
            React.createElement("div", { className: "transfer-actions" },
                React.createElement("div", { className: "transfer-actions-left" }, this.getLeftAction(transfer)),
                React.createElement("div", { className: "transfer-actions-right" }, this.getRightAction(transfer)))));
    }
}
